import {
  GuidIdAndLabel,
  StationOrLocationItem,
} from '../../../integrated-client/models'

export interface IGeoGroupsEditorData {
  id?: string | null;
  supplier?: GuidIdAndLabel;
  supplierValue?: string | null;
  oneAirLocation?: StationOrLocationItem;
  effectiveFrom?: object | null;
  effectiveTo?: object | null;
  allowEdit?: boolean;
  disabled?: boolean;
}

export interface IEditorData {
  geoGroupsEditorData: IGeoGroupsEditorData,
  validation?: any
}

export class GeoGroupsEditorData implements IGeoGroupsEditorData {
  id?: string | null;
  supplier?: GuidIdAndLabel;
  supplierValue?: string | null;
  oneAirLocation?: StationOrLocationItem;
  effectiveFrom?: object | null;
  effectiveTo?: object | null;
  allowEdit?: boolean;
  disabled?: boolean;

  constructor() {
    this.disabled = false
  }
}

export class EditorData implements IEditorData {

  geoGroupsEditorData: IGeoGroupsEditorData
  validation?: any

  constructor() {
    this.geoGroupsEditorData = new GeoGroupsEditorData()
  }
}
